module.exports = __webpack_public_path__ + "static/media/message-preferences.6e29e956.svg";